import { Icon } from "@iconify/react";
import { Button, Col, Form, Input, Row, Space, Typography, UploadProps, Select, message,Grid } from "antd";
import { useState, ReactNode, useCallback, useEffect, useRef } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import * as yup from "yup";
import { ContentWrapper, DataTable, WrapperCard, PDFViewer, PDFView } from "~/Components";
import styles from "../../ContractManagement/SPA/SPA.module.scss";
import { ErrorMessage, Field, FieldProps, Formik, FormikTouched, useFormik } from "formik";
import { useAuth } from "~/Hooks/useAuth";
import { filter, map, some, sortBy, uniqueId } from "lodash";
import { useNotification } from "~/Hooks/useNotification";
import moment from "moment";
import { useQuery } from "~/Hooks/useQuery";
import { get, post, put } from "@services/api.service";
import { Subsidiary } from "../Subsidiaries/Subsidiaries";
import { error } from "console";
import { budget, spaBudget } from "~/Utils/StringConstants";

interface FormItems {
  approver: {
    designation: any;
    userName: string;
    userEmail: string;
    subsidiary: string;
    division: string;
    authorityGroup: string;
    budget: string;
  }[];
}

const defaultValue = {
  approver: [
    {
      userName: "",
      userEmail: "",
      designation: "",
      subsidiary: "",
      division: "",
      authorityGroup: "",
      budget: "",
    },
  ],
} as FormItems;

var newDocId = 100;

export const AddApprover = () => {
  const [docsList, setDocsList] = useState<any>([]);
  const [record, setRecord] = useState<any>({});
  const [isSubmitLoading, setSubmitLoading] = useState(false);
  const { openNotification } = useNotification();
  const [isloading, setIsLoading] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [initialValues, setInitialValues] = useState<FormItems>(defaultValue);
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [divisionData, setDivisionData] = useState([]);
  const [subsidiaryData, setSubsidiaryData] = useState([]);
  const [subsidiaryId, setSubsidiaryId] = useState<any>();
  const [divisionName, setDivisionName] = useState([]);
  const [subsidiaryName, setSubsidiaryName] = useState([]);
  const [approverData, setApproverData] = useState([]);
  const [approverDataByEmail, setApproverDataByEmail] = useState<any>([]);
  const [deletedIds, setDeletedIds] = useState<any>([]);
  const [selectedNames, setSelectedNames] = useState<string[]>([]);
  const [selectDesignation, setSelectDesignation] = useState<any>([]);
  const query = useQuery();
  const authority = query?.get("authority") || "";
  const id = query?.get("id") || "";
  const viewItem = query?.get("view") || "";
  const [subsidiary, setSubsidiary] = useState();
  const [division, setDivision] = useState();
  const [designation, setDesignation] = useState();
  const [budget, setBudget] = useState();
  let previousLength = useRef<any>(null);
  const {useBreakpoint}=Grid;
  const screens = useBreakpoint();
  useEffect(() => {
    if (id) {
      get(`v1/spa/approver/approver-detail?uniqueId=${id}`)
        .then((res: any) => {
          const designation = res?.response?.data?.designation;
          const budget = res?.response?.data?.budget;
          const values = {
            approver: [
              {
                userName: res.response.data.userName,
                userEmail: res.response.data.userEmail,
                budget: budget,
                designation: designation,
                subsidiary: res.response.data.subsidiary,
                division: res.response.data.division,
                authorityGroup: res.response.data.authorityGroup,
              },
            ],
          } as FormItems;
          setInitialValues(values);
          setDesignation(designation);
          setBudget(budget);
          setDivision(res.response.data.division);
          setSubsidiary(res.response.data.subsidiary);
        })
        .catch(() => {});
    }
  }, [id]);

  const onSubmit = async (values: any) => {
    let approver: any = [...values.approver];
      
    approver = approver.map((item: any) => ({
      ...item,
      authorityGroup: authority,
      subsidiary: item.subsidiary.split("/")[1] ? item.subsidiary.split("/")[1] : item.subsidiary,
      designation:
      item.designation?.toUpperCase() === "AIRPORT MANAGER"
        ? "Airport Manager"
        : item.designation,
    }));

    const payload: any = {
      watcher: [...approver],
    };
    const updateWatcher = approver.map((item: any) => {
      return { ...item, uniqueId: id };
    });
    updateWatcher[0];
    setSubmitLoading(true);
    let updateUrl = id ? `update-approver` : `create-approver`;
    if (id) {
      put(`v1/spa/approver/${updateUrl}`, updateWatcher[0])
        .then((res: any) => {
          if (res) {
            openNotification({
              title: "Success",
              message: `Approver ${id ? "Updated" : "added"}  successfully`,
              type: "success",
            });
          }
          setSubmitLoading(false);
          navigate(`/approver?authority=${authority}`);
        })
        .catch((err) => {
          openNotification({
            title: err,
            message: "",
            type: "error",
          });
          setSubmitLoading(false);
        });
    } else {
      post(`v1/spa/approver/${updateUrl}`, approver)
        .then((res: any) => {
          if (res) {
            openNotification({
              title: "Success",
              message: `Approver added successfully`,
              type: "success",
            });
          }
          setSubmitLoading(false);
          navigate(`/approver?authority=${authority}`);
        })
        .catch((err) => {
          // openNotification({
          //   title: err,
          //   message: "",
          //   type: "error",
          // });
          setSubmitLoading(false);
        });
    }
  };
  const validationSchema2 = yup.object().shape({
    approver: yup.array().of(
      yup.object().shape({
        userName: yup
          .string()
          .required("Name required"),
        userEmail: yup
          .string()
          .required("Email required"),
        designation: yup.string().required("Designation is required"),
        subsidiary: yup.string().required("Subsidiary/Division is required"),
        division: yup.string().required("Cost Centre is required"),
          budget: yup.string().when(["designation", "authority"], {
        is: (designation:any) => {
          return authority === "headOfSubsidiary" && designation === "R2";
        },
        then: (schema) => schema.required("Budget required"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      })
    ),
  });

  const getSubsidiaryRecords = (subsidiaryId?: any) => {
    const subsidiaryUrl = `v1/subsidiary/all-subsidiary`;
    get(subsidiaryUrl)
      .then((res: any) => {
        if (subsidiary && id && res && res.response && res.response.data) {
          const filteredSubsidiary = res.response.data.find((item: any) => item.name == subsidiary);
          if (filteredSubsidiary) {
            const filterSubsidiaryId = filteredSubsidiary.subsidiaryId;
            if (subsidiaryId === undefined) {
              setSubsidiaryId(filterSubsidiaryId);
            }
          } else {
            console.log("No matching subsidiary found for the given name.");
          }
          const responseData = res.response.data;
          if (responseData) {
            setSubsidiaryData(responseData);
          } else {
            console.error("No records found in the response");
            setSubsidiaryData([]);
          }
        } else if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          setSubsidiaryData(responseData);
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        openToast({
          content: "Getting Subsidiary failed",
          type: "error",
        });
      });

    if (subsidiaryId || id) {
      const divisionUrl = `/v1/division/get-all-divisionBySubsidiary?subsidiary=${subsidiaryId}`;
      get(divisionUrl)
        .then((res: any) => {
          if (res && res.response && res.response.data) {
            const responseData = res.response.data;

            if (responseData) {
              setDivisionData(responseData);
            } else {
              console.error("No records found in the response");
              setDivisionData([]);
            }
          } else {
            console.error("Unexpected response structure:", res);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          openToast({
            content: "Getting Divisions failed",
            type: "error",
          });
        });
    }

    if (divisionData.length > 0 || id) {
      const subsidiaryUrl = `/v1/user/get-active-user-list`;
      get(subsidiaryUrl)
        .then((res: any) => {
          if (res && res.response && res.response.data) {
            const responseData = res.response.data;
            if (responseData) {
              setApproverData(responseData);
              setApproverDataByEmail(sortBy(responseData, ["email"]));
            } else {
              console.error("No records found in the response");
              setApproverData([]);
            }
          } else {
            console.error("Unexpected response structure:", res);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          openToast({
            content: "Getting Approvers failed",
            type: "error",
          });
        });
    }
  };

  useEffect(() => {
    if (id) {
      getSubsidiaryRecords(subsidiaryId);
    } else {
      getSubsidiaryRecords();
    }
  }, [divisionName, subsidiary, subsidiaryId, selectDesignation, division]);

  return (
    <>
      <ContentWrapper
        loading={isloading}
        customTitle={
          <Space align="start">
            <Icon
              onClick={() => navigate(-1)}
              icon="akar-icons:arrow-left"
              style={{
                fontSize: "1.8rem",
                cursor: "pointer",
                color: styles.primary,
                marginRight: styles.whitespace1,
              }}
            />
            <span>
              <Typography.Title
                level={3}
                style={{ margin: 0 }}
              >
                {viewItem ? "View" : id ? "Edit" : "Add"} Approver
              </Typography.Title>
            </span>
          </Space>
        }
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => onSubmit(values)}
          validationSchema={validationSchema2}
          enableReinitialize={true}
        >
          {(props) => {
            const { values, setFieldValue, setFieldTouched, setErrors, errors } = props;
            useEffect(() => {
              if (initialValues.approver.length > 0) {
                const initialSelectedNames = initialValues.approver.map((watcher) => watcher.userName);
                setSelectedNames(initialSelectedNames);
              }
            }, [initialValues]);

            useEffect(() => {
              initialValues.approver.forEach((approver: any, index: any) => {
                if (approver) {
                  setFieldValue(`approver[${index}].userEmail`, approver.userEmail);
                  setFieldValue(`approver[${index}].userName`, approver.userName);
                  setFieldValue(`approver[${index}].designation`, approver.designation);
                  setFieldValue(`approver[${index}].subsidiary`, approver.subsidiary);
                  setFieldValue(`approver[${index}].division`, approver.division);
                  setSubsidiaryName(approver.subsidiary);
                }
              });
            }, [initialValues]);
            if (selectDesignation.length <= 0) {
              setSelectDesignation("R2");
            }

            let value;
            useEffect(() => {
              let index = initialValues.approver.length - 1;
              setTimeout(() => {
                setFieldTouched(`approver[${index}].userEmail`, false);
                setFieldTouched(`approver[${index}].userName`, false);
                setFieldTouched(`approver[${index}].designation`, false);
                setFieldTouched(`approver[${index}].subsidiary`, false);
                setFieldTouched(`approver[${index}].division`, false);
              }, 0);
            }, [id, initialValues, props.values]);

            useEffect(() => {
              setErrors({});
            }, [subsidiaryId]);

            if (!id) {
              props.values.approver.forEach((approver: any) => {
                if (approver.subsidiary) {
                  const subsidiaryName = approver.subsidiary.split("/")[1];
                  setSubsidiaryName(subsidiaryName);
                  const subsidiaryId = approver.subsidiary.split("/")[0];
                  // setSubsidiaryId(subsidiaryId);
                }
              });
            }

            const getReviewerCount = (role: any) => {
              switch (role) {
                case "MD/GCEO":
                  return 5;
                case "GCFO/GCOO":
                  return 4;
                case "HEADOFSUBSIDIARY":
                  return 2;
                case "AIRPORTMANAGER":
                  return 3;
                default:
                  return 0;
              }
            };

            const getDesignations = (count: any) => {
              switch (count) {
                case 5:
                  return ["R1", "R2", "R3", "GCEO", "MD"];
                case 4:
                  return ["R1", "R2", "GCFO", "GCOO", "COO", "CAO", "CFO"];
                case 2:
                  return ["R1", "R2", "HEAD OF SUBSIDIARY"];
                case 3:
                  return ["AIRPORT MANAGER","APC MEMBER","APC SECRETARIAT"];
                default:
                  return [];
              }
            };

            const getAvailableDesignations = (currentIndex: any, designations: any, approverValues: any) => {
              if (authority !== "headOfSubsidiary") {
                return designations;
              }

              const isR1Selected = approverValues.some(
                (approver: any, index: any) => index !== currentIndex && approver.designation === "R1"
              );

              if (isR1Selected) {
                return designations.filter((designation: any) => designation !== "R1");
              }

              return designations;
            };

            const reviewerCount = getReviewerCount(authority.toUpperCase());
            const designations = getDesignations(reviewerCount);
            return (
              <Form
                layout="vertical"
                onFinish={props.handleSubmit}
              >
                <div style={{ marginTop: 16, maxHeight: screens.xs ? 400 : "auto"}}>
                  <div>
                    {
                      <>
                        <div
                          style={{
                            width: "100%",
                            marginBottom: 16,
                          }}
                        >
                          <Typography.Title
                            level={4}
                            style={{ marginBottom: "25px" }}
                          >
                            Approver Details (
                            {authority === "headOfSubsidiary"
                              ? "Head of Subsidiary"
                              : authority === "airportManager"
                              ? "Airport Procurement Committee (APC)"
                              : authority === "gcfo/gcoo"
                              ? "GCFO/CFO/CAO/COO"
                              : authority.toUpperCase()}
                            )
                          </Typography.Title>
                          <div>
                            {props.values.approver.map((signer, i) => {
                              const showBudget = authority === "headOfSubsidiary" && signer.designation === "R2";
                              const colSpans = {
                                designation:screens?.xs?24:4,
                                budget: screens?.xs?24:4,
                                subsidiary: screens?.xs?24:4,
                                division: screens?.xs?24:4,
                                userName: screens?.xs?24:showBudget ? 3 : 5,
                                userEmail: screens?.xs?24:showBudget ? 3 : 5,
                                delete: screens?.xs?24:showBudget ? 1 : 2,
                              };
                              return (
                                <Row
                                  gutter={[16, 16]}
                                  align="top"
                                  key={`singer${i}`}
                                >
                                  <Col span={colSpans.designation}>
                                    <Form.Item label="Designation">
                                      <Field name={`approver[${i}].designation`}>
                                        {({ field, form }: FieldProps) => {
                                          return (
                                            <Select
                                              getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                              className={viewItem ? "viewItem" : "none"}
                                              disabled={viewItem ? true : false}
                                              showSearch
                                              value={field.value}
                                              filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                              }
                                              onBlur={() => props.setFieldTouched("designation", true)}
                                              onChange={(value) => {
                                                form.setFieldValue(`approver[${i}].designation`, value);
                                                setSelectDesignation(value);
                                              }}
                                            >
                                              {/* {designations &&
                                                designations.map((item: any) => (
                                                  <Select.Option
                                                    value={item}
                                                    key={item}
                                                  >
                                                    {item}
                                                  </Select.Option>
                                                ))} */}
                                              {getAvailableDesignations(i, designations, props.values.approver).map(
                                                (item: any) => (
                                                  <Select.Option
                                                    value={item}
                                                    key={item}
                                                  >
                                                    {item}
                                                  </Select.Option>
                                                )
                                              )}
                                            </Select>
                                          );
                                        }}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`approver[${i}].designation`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  {showBudget && (
                                    <Col
                                      span={colSpans.budget}
                                      key={i}
                                    >
                                      <Form.Item label="Budget">
                                        <Field name={`approver[${i}].budget`}>
                                          {({ field, form }: FieldProps) => {
                                            return (
                                              <Select
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                className={viewItem ? "viewItem" : "none"}
                                                showSearch
                                                disabled={viewItem ? true : false}
                                                value={field.value}
                                                filterOption={(input, option: any) =>
                                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onBlur={() => props.setFieldTouched(`approver[${i}].budget`, true)}
                                                onChange={(value) => {
                                                  form.setFieldValue(`approver[${i}].budget`, value);
                                                  setSelectDesignation(value);
                                                }}
                                              >
                                                {spaBudget?.map((item: any) => (
                                                  <Select.Option
                                                    value={item}
                                                    key={item}
                                                  >
                                                    {item}
                                                  </Select.Option>
                                                ))}
                                              </Select>
                                            );
                                          }}
                                        </Field>
                                        <Typography.Text type="danger">
                                          <ErrorMessage name={`approver[${i}].budget`} />
                                        </Typography.Text>
                                      </Form.Item>
                                    </Col>
                                  )}
                                  <Col span={colSpans.subsidiary}>
                                    <Form.Item label="Subsidiary/Division">
                                      <Field name={`approver[${i}].subsidiary`}>
                                        {({ field, form }: FieldProps) => (
                                          <Select
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            className={viewItem ? "viewItem" : "none"}
                                            disabled={viewItem ? true : false}
                                            showSearch
                                            value={field.value}
                                            filterOption={(input, option: any) =>
                                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            onBlur={() => form.setFieldTouched(`approver[${i}].subsidiary`, true)}
                                            onChange={(value) => {
                                              const [id, name] = value.split("/");
                                              setSubsidiaryName(name);
                                              setSubsidiaryId(id);
                                              form.setFieldValue(`approver[${i}].subsidiary`, value);
                                              form.setFieldValue(`approver[${i}].division`, "");
                                              getSubsidiaryRecords(id);
                                            }}
                                            // status={
                                            //   form.touched.watcher?.[i]?.subsidiary && form.errors.watcher?.[i]?.subsidiary ? "error" : ""
                                            // }
                                          >
                                            {subsidiaryData.map((values: any, index: any) => (
                                              <Select.Option
                                                value={`${values.subsidiaryId}/${values.name}`}
                                                key={index}
                                              >
                                                {values.name}
                                              </Select.Option>
                                            ))}
                                          </Select>
                                        )}
                                      </Field>

                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`approver[${i}].subsidiary`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  <Col span={colSpans.division}>
                                    <Form.Item label="Cost Centre">
                                      <Field name={`approver[${i}].division`}>
                                        {({ field, form }: FieldProps) => (
                                          <Select
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            className={viewItem ? "viewItem" : "none"}
                                            disabled={
                                              viewItem ? true : props.values.approver[i].subsidiary ? false : true
                                            }
                                            showSearch
                                            value={field.value}
                                            filterOption={(input, option: any) =>
                                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            // onBlur={() => props.setFieldTouched("subsidiary", true)}
                                            onChange={(value) => {
                                              const [id, name] = value.split("/");
                                              setDivisionName(value);
                                              form.setFieldValue(`approver[${i}].division`, value);
                                            }}
                                            // status={(props.touched.approver && props.errors.approver && "error") || ""}
                                          >
                                            {divisionData &&
                                              divisionData.map((item: any) => (
                                                <Select.Option
                                                  value={item.division}
                                                  key={item.uniqueId}
                                                >
                                                  {item.division}
                                                </Select.Option>
                                              ))}
                                          </Select>
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`approver[${i}].division`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  <Col span={colSpans.userName}>
                                    <Form.Item label="User Name">
                                      <Field name={`approver[${i}].userName`}>
                                        {({ field, form }: FieldProps) => (
                                          <Select
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            className={viewItem ? "viewItem" : "none"}
                                            disabled={viewItem ? true : false}
                                            showSearch
                                            {...field}
                                            style={{ width: "100%" }}
                                            placeholder="Select a name"
                                            // onBlur={() => props.setFieldTouched(`approver[${i}].userName`, false)}
                                            onChange={(value, option: any) => {
                                              const selectedEmail = option ? option.label : "";
                                              form.setFieldValue(`approver[${i}].userName`, value);
                                              form.setFieldValue(`approver[${i}].userEmail`, selectedEmail);
                                            }}
                                            filterOption={(input, option: any) =>
                                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                          >
                                            {approverData
                                              .filter((name: any) => name.name !== "")
                                              .map((user: any, index: any) => (
                                                <Select.Option
                                                  key={index}
                                                  value={user.name}
                                                  label={user.email}
                                                >
                                                  {user.name}
                                                </Select.Option>
                                              ))}
                                          </Select>
                                        )}
                                      </Field>

                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`approver[${i}].userName`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>

                                  <Col span={colSpans.userEmail}>
                                    <Form.Item label="User Email ID">
                                      <Field
                                        name={`approver[${i}].userEmail`}
                                        initialValue="static@example.com"
                                      >
                                        {({ field, form }: FieldProps) => {
                                          return (
                                            <Select
                                              getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                              showSearch
                                              disabled={
                                                viewItem ? true : props.values.approver[i].division ? false : true
                                              }
                                              className={viewItem ? "viewItem" : "none"}
                                              {...field}
                                              style={{ width: "100%" }}
                                              placeholder="Select an email"
                                              onChange={(value, option: any) => {
                                                const selectedName = option ? option.label : "";
                                                form.setFieldValue(`approver[${i}].userEmail`, value);
                                                form.setFieldValue(`approver[${i}].userName`, selectedName);
                                              }}
                                              filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                              }
                                            >
                                              {approverDataByEmail
                                                .filter((email: any) => email.email !== "")
                                                .map((email: any, index: any) => (
                                                  <Select.Option
                                                    key={index}
                                                    value={email.email}
                                                    label={email.name}
                                                  >
                                                    {email.email}
                                                  </Select.Option>
                                                ))}
                                            </Select>
                                          );
                                        }}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`approver[${i}].userEmail`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  {!viewItem && (
                                    <Col span={colSpans.delete}>
                                      <Form.Item label=" ">
                                        <Button
                                          type="link"
                                          danger
                                          disabled={props.values.approver.length === 1}
                                          onClick={() => {
                                            const approver = [...props.values.approver];
                                            approver.splice(i, 1);
                                            props.setValues({
                                              ...props.values,
                                              approver,
                                            });
                                          }}
                                        >
                                          <Icon
                                            icon="fluent:delete-16-regular"
                                            style={{
                                              color: styles.strawberry,
                                              cursor: "pointer",
                                              fontSize: 20,
                                            }}
                                          />
                                        </Button>
                                      </Form.Item>
                                    </Col>
                                  )}
                                </Row>
                              );
                            })}
                          </div>
                          {!viewItem && !id && (
                            <Row gutter={16}>
                              <Col
                                span={24}
                                style={{ textAlign: "right", marginBottom: 16 }}
                              >
                                <Button
                                  type="text"
                                  icon={<Icon icon="akar-icons:plus" />}
                                  disabled={props.values.approver.some(
                                    (val) => val.userName === "" || val.userEmail === "" || id !== ""
                                  )}
                                  onClick={() =>
                                    props.setValues({
                                      ...props.values,
                                      approver: [
                                        ...props.values.approver,
                                        {
                                          userName: "",
                                          userEmail: "",
                                          designation: "",
                                          subsidiary: "",
                                          division: "",
                                          authorityGroup: authority,
                                          budget: "",
                                        },
                                      ],
                                    })
                                  }
                                >
                                  Add Another
                                </Button>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </>
                    }
                    {!viewItem && (
                      <Row>
                        <Col
                          xs={24}
                          md={24}
                          style={{ textAlign: "right" }}
                        >
                          <Space>
                            <Button
                              htmlType="submit"
                              type="primary"
                              loading={isSubmitLoading}
                              disabled={Object.keys(errors).length > 0}
                            >
                              Submit
                            </Button>
                          </Space>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </ContentWrapper>
    </>
  );
};
